import { create } from 'zustand';

export type UserRole = 'user' | 'superadmin';

export interface AuthUser {
  id: string;
  email: string;
  displayName: string;
  role: UserRole;
}

interface AuthState {
  user: AuthUser | null;
  accessToken: string | null;
  setSession: (session: { user: AuthUser; accessToken: string }) => void;
  clear: () => void;
}

/**
 * Store d'auth — en mémoire uniquement.
 * Le refresh token est en cookie httpOnly côté API, donc pas accessible JS.
 * Au reload de la page, on tente un /auth/refresh silencieux pour récupérer
 * une session si le cookie est encore valide.
 */
export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  accessToken: null,
  setSession: (session) =>
    set({ user: session.user, accessToken: session.accessToken }),
  clear: () => set({ user: null, accessToken: null }),
}));
